module.exports = __webpack_public_path__ + "img/art-53.aec9a384.png";